import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconEmail: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 13.13L6 8.62a.73.73 0 0 1 .75-.75h10.5a.73.73 0 0 1 .75.75zm-6-3v5.26a.73.73 0 0 0 .75.75h10.5a.73.73 0 0 0 .75-.75v-5.27l-6 4.51z"
    />
  </Svg>
)
